import React, { useState, useEffect, useContext } from 'react';


export const AccessError = (prop: any) => {
    useEffect(() => {

    }, [])


    return (
        <React.Fragment>
            <div className="metaportal_fn_404">
                <div className="container small">
                    <div className="message_holder">
                        <h2 className="text-lg font-semibold">Access Denied</h2>
                        <button className="metaportal_fn_button" onClick={() => window.location.assign(process.env.REACT_APP_HOME)}>
                            Return to home
                        </button>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}